<template>
  <div class="row table-sm mr-0 ml-0 p-0">
    <div class="row table-sm mr-0 ml-0 p-0 mb-3 width-100">
      <div
        class="
          col-7
          p-0
          align-self-center
          font-weight-bold
          d-flex
          align-items-center
          w-reset
          mb-sm-2
        "
      >
        <h5 class="d-inline mr-2 font-weight-bold">
          {{ $t("message.aggrement") }}
        </h5>
        <crm-refresh @c-click="refresh()"></crm-refresh>
        <div class="text-center d-flex sorddata ml-3">
          <el-input
            size="mini"
            :placeholder="$t('message.search')"
            prefix-icon="el-icon-search"
            v-model="filterForm.search"
            clearable
          ></el-input>
        </div>
      </div>
      <div
        class="
          col-5
          align-items-center align-self-center
          text-right
          pr-0
          d-flex
          justify-content-end
          w-reset
        "
      >
        <el-button
          size="mini"
          @click="drawerCreate = true"
          icon="el-icon-circle-plus-outline"
        >
          {{ $t("message.create") }}
        </el-button>
        <export-excel
          v-can="'contracts.excel'"
          class="btn excel_btn"
          :data="list"
          :fields="excel_fields"
          @fetch="controlExcelData()"
          worksheet="Договоры"
          name="Договоры.xls"
        >
          <el-button size="mini">
            <i class="el-icon-document-delete"></i> Excel
          </el-button>
        </export-excel>
        <crm-column-settings
          :columns="columns"
          :modelName="'contracts'"
          @c-change="updateColumn"
        ></crm-column-settings>
      </div>
    </div>
    <table class="table table-bordered table-hover" v-loading="loadingData">
      <crm-pagination
        :pagination="pagination"
        @c-change="updatePagination"
      ></crm-pagination>
      <thead>
        <tr>
          <crm-th
            :column="columns.id"
            :sort="sort"
            @c-change="updateSort"
          ></crm-th>
          <crm-th
            :column="columns.number"
            :sort="sort"
            @c-change="updateSort"
          ></crm-th>
          <crm-th
            :column="columns.parent_id"
            :sort="sort"
            @c-change="updateSort"
          ></crm-th>
          <crm-th
            :column="columns.begin_date"
            :sort="sort"
            @c-change="updateSort"
          ></crm-th>
          <crm-th
            :column="columns.end_date"
            :sort="sort"
            @c-change="updateSort"
          ></crm-th>
          <crm-th
            :column="columns.sum"
            :sort="sort"
            @c-change="updateSort"
          ></crm-th>
          <crm-th
            :column="columns.orders_amount"
            :sort="sort"
            @c-change="updateSort"
          ></crm-th>
          <crm-th
            :column="columns.status_id"
            :sort="sort"
            @c-change="updateSort"
          ></crm-th>
          <crm-th
            :column="columns.comment"
            :sort="sort"
            @c-change="updateSort"
          ></crm-th>
          <crm-th
            :sort="sort"
            :column="columns.updated_at"
            @c-change="updateSort"
          ></crm-th>
          <crm-th
            :sort="sort"
            :column="columns.print"
            @c-change="updateSort"
          ></crm-th>
          <crm-th
            :sort="sort"
            :column="columns.settings"
            @c-change="updateSort"
          ></crm-th>
        </tr>
        <tr>
          <th v-if="columns.id.show">
            <el-input
              clearable
              size="mini"
              class="id_input"
              v-model="filterForm.id"
              :placeholder="columns.id.title"
            ></el-input>
          </th>
          <th v-if="columns.number.show">
            <el-input
              size="mini"
              v-model="filterForm.number"
              :placeholder="columns.number.title"
              clearable
            >
            </el-input>
          </th>
          <th v-if="columns.parent_id.show">
            <el-input
              size="mini"
              v-model="filterForm.parent_id"
              :placeholder="columns.parent_id.title"
              clearable
            >
            </el-input>
          </th>
          <th v-if="columns.begin_date.show">
            <el-input
              size="mini"
              v-model="filterForm.begin_date"
              :placeholder="columns.begin_date.title"
              clearable
            >
            </el-input>
          </th>
          <th v-if="columns.end_date.show">
            <el-input
              size="mini"
              v-model="filterForm.end_date"
              :placeholder="columns.end_date.title"
              clearable
            >
            </el-input>
          </th>
          <th v-if="columns.sum.show">
            <el-input
              size="mini"
              v-model="filterForm.sum"
              :placeholder="columns.sum.title"
              clearable
            >
            </el-input>
          </th>
          <th v-if="columns.orders_amount.show">
            <el-input
              size="mini"
              v-model="filterForm.orders_amount"
              :placeholder="columns.orders_amount.title"
              clearable
            >
            </el-input>
          </th>
          <th v-if="columns.status_id.show">
            <el-input
              size="mini"
              v-model="filterForm.status_id"
              :placeholder="columns.status_id.title"
              clearable
            >
            </el-input>
          </th>
          <th v-if="columns.comment.show">
            <el-input
              size="mini"
              v-model="filterForm.comment"
              :placeholder="columns.comment.title"
              clearable
            >
            </el-input>
          </th>

          <th v-if="columns.updated_at.show">
            <el-date-picker
              :format="'dd.MM.yyyy'"
              :value-format="'dd.MM.yyyy'"
              v-model="filterForm.updated_at"
              :placeholder="columns.updated_at.title"
              size="mini"
            >
            </el-date-picker>
          </th>

          <th v-if="columns.created_at.show">
            <el-date-picker
              :format="'dd.MM.yyyy'"
              :value-format="'dd.MM.yyyy'"
              v-model="filterForm.created_at"
              :placeholder="columns.created_at.title"
              size="mini"
            >
            </el-date-picker>
          </th>
          <th v-if="columns.print.show"></th>
          <th v-if="columns.settings.show"></th>
        </tr>
      </thead>

      <transition-group name="flip-list" tag="tbody">
        <tr
          v-for="contracts in list"
          :key="contracts.id"
          class="cursor-pointer"
        >
          <td v-if="columns.id.show">{{ contracts.id }}</td>
          <td v-if="columns.number.show">{{ contracts.number }}</td>
          <td v-if="columns.parent_id.show">{{ contracts.parent_id }}</td>
          <td v-if="columns.begin_date.show">
            {{ contracts.begin_date  }}
          </td>
          <td v-if="columns.end_date.show">
            {{ contracts.end_date  }}
          </td>
          <td v-if="columns.sum.show">{{ contracts.sum | formatMoney }}</td>
          <td v-if="columns.orders_amount.show">
            {{ contracts.orders_amount | formatMoney }}
          </td>
          <td v-if="columns.status_id.show">{{ contracts.status_id }}</td>
          <td v-if="columns.comment.show">{{ contracts.comment }}</td>

          <td v-if="columns.updated_at.show">
            {{ contracts.updated_at  }}
          </td>
          <td v-if="columns.created_at.show">
            {{ contracts.created_at }}
          </td>
          <td v-if="columns.print.show">
            <el-button
              v-can="'printCenter.print'"
              :loading="waitingPrint"
              @click="print('contract/print', contracts.id)"
              >{{ $t("message.print") }}</el-button
            >
          </td>
          <td v-if="columns.settings.show" class="settings-td">
            <crm-setting-dropdown
              :model="contracts"
              name="contracts"
              :actions="actions"
              @edit="edit"
              @delete="destroy"
            >
            </crm-setting-dropdown>
          </td>
        </tr>
      </transition-group>
    </table>
    <el-drawer
      title="Новый тег"
      :append-to-body="true"
      :visible.sync="drawerCreate"
      size="60%" :wrapperClosable="false"
      :drawer="drawerCreate"
      @close="reloadIfChanged"
    >
      <div>
        <crm-create
          :organizationId="organizationId"
          :reloadModel="reopenUpdate"
          @c-close="reloadIfChanged('drawerCreate')"
        ></crm-create>
      </div>
    </el-drawer>
    <el-drawer
      title="Изменить тег"
      :append-to-body="true"
      :visible.sync="drawerUpdate"
      size="60%" :wrapperClosable="false"
      :drawer="drawerUpdate"
      @open="reopenUpdate = true"
      @close="reopenUpdate = false"
      @closed="emptyModel"
    >
      <div>
        <crm-update
          :reloadModel="reopenUpdate"
          @open="reopenUpdate = true"
          @c-close="closeDrawer"
          @closed="emptyModel"
        ></crm-update>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import CrmCreate from "./components/contract-create";
import CrmUpdate from "./components/contract-update";
import list from "@/utils/mixins/list";
import print from "@/utils/mixins/print";

export default {
  mixins: [list, print],
  name: "contractsList",
  components: {
    CrmUpdate,
    CrmCreate,
  },
  props: {
    organizationId: { default: null },
  },
  data() {
    return {
      waitingPrint: false,
      drawerCreate: false,
      drawerUpdate: false,
      reopenUpdate: false,
      excel_data: [],
      excel_fields: {},
      loadingData: false,
    };
  },
  computed: {
    ...mapGetters({
      list: "contracts/list",
      columns: "contracts/columns",
      pagination: "contracts/pagination",
      filter: "contracts/filter",
      sort: "contracts/sort",
    }),
    actions: function () {
      return ["edit", "delete"];
    },
  },
  async created() {},
  async mounted() {
    this.controlExcelData();
  },
  watch: {
    columns: {
      handler: function () {
        this.controlExcelData();
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions({
      updateList: "contracts/index",
      updateSort: "contracts/updateSort",
      updateFilter: "contracts/updateFilter",
      updateColumn: "contracts/updateColumn",
      updatePagination: "contracts/updatePagination",
      editModel: "contracts/show",
      empty: "contracts/empty",
      delete: "contracts/destroy",
      refreshcontractData: "contracts/refreshData",
    }),
    fetchData() {
      const query = {
        ...this.filter,
        ...this.pagination,
        ...this.sort,
        organization_id: this.organizationId,
      };
      if (!this.loadingData) {
        this.loadingData = true;
        this.updateList(query)
          .then((res) => {
            this.loadingData = false;
          })
          .catch((err) => {
            this.loadingData = false;
          });
      }
    },
    refresh() {
      this.refreshcontractData()
        .then((res) => {
          this.filterForm = JSON.parse(JSON.stringify(this.filter));
        })
        .catch((err) => {});
    },
    async edit(model) {
      await this.editModel({ id: model.id, contract_service: true })
        .then(async (res) => {
          this.drawerUpdate = true;
        })
        .catch((err) => {});
    },
    async show(model) {
      await this.showModel(model.id)
        .then((res) => {
          this.drawerShow = true;
        })
        .catch((err) => {});
    },
    controlExcelData() {
      this.excel_fields = {};
      for (let key in this.columns) {
        if (this.columns.hasOwnProperty(key)) {
          let column = this.columns[key];
          if (column.show && column.column !== "settings") {
            this.excel_fields[column.title] = column.column;
          }
        }
      }
    },
    destroy(model) {
      this.delete(model.id)
        .then((res) => {
          this.$notify({
            title: 'Успешно',
            type: "success",
            offset: 130,
            message: res.message
          });
          this.fetchData();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    emptyModel() {
      this.empty();
    },
  },
};
</script>
